export default __webpack_public_path__ + "static/media/html5front.a4816858.svg";